// (react import removed: only createContext was used)
import { createSharedContext } from '@twisto/utils'

type ModalContextApi = {
  isInModal: boolean
}

export const ModalContext = createSharedContext<ModalContextApi | null>('components/atoms/modal/modal-context/modal-context#0', null)
